 const bgimgs = [
    {
        id: 1,
        img: 'https://static.vecteezy.com/system/resources/previews/000/732/677/large_2x/italian-food-background-photo.jpg'
    },
    {
        id: 2,
        img: 'https://media02.stockfood.com/largepreviews/Mzg2MjA4MjYx/12458331-Italian-food-background-with-ravioli-vine-tomatoes-basil-spaghetti-spinach-onion-parmesan-olive-oil-garlic.jpg'
    },
    {
        id: 3,
        img: 'https://img.freepik.com/premium-photo/food-background-salt-pepper-rosemary-branch-wooden-stand-salad-fork-spoon-red-napkin-wooden-cooking-background-food-cooking-background-ingredients-cooking-food-background-mock-up_253362-17480.jpg?w=2000'
    },
    {
        id: 4,
        img: 'https://static.vecteezy.com/system/resources/previews/004/280/141/large_2x/healthy-food-herbs-spices-for-use-as-cooking-ingredients-on-a-wooden-background-with-fresh-organic-vegetables-on-wood-the-concept-of-food-ingredients-with-variety-on-the-rustic-table-free-photo.jpg'
    },
]

export default bgimgs